/**
 * Goodword Books - Product Page Engine v8.7
 * v8.7: ISBN vs PRODUCT ID label — the admin can mark a product's code as an
 *   internal Product ID (books.code_type='id'); the Details tab then shows
 *   "Product ID: gdmg502" instead of "ISBN: …". Nothing else changes.
 * v8.6 (below) unchanged otherwise.
 * v8.6: THUMBNAIL STRIP FIX — the strip could over-scroll past the last
 *   thumbnail into blank space (even fully empty). The clamp used the strip's
 *   TOTAL width; it now uses a live limit (content minus visible width) for the
 *   arrows AND touch-drag, so it stops exactly at the last thumbnail.
 * v8.5 (below) unchanged otherwise.
 * v8.5: STYLE-ONLY (renderImage). Identical logic to v8.4 — only the image-area
 *       CSS values changed to match goodwordbooks.com (measured live):
 *         • Hero cover: max-width 400px, centred, 5px 10px padding, clean image
 *           (removed the transform transition "effect"). No shadow/border/radius.
 *         • Thumbnails: 133x75 landscape, object-fit cover, no border/radius
 *           (were 80x80 bordered squares). Slider logic/values unchanged — same
 *           fixed-size strip, arrows, touch-drag, lightbox as v8.4.
 *       NOTHING else touched: API, data sources, colour/variant system, all
 *       render functions are byte-for-byte v8.4.
 * v8.4: (1) The big hero ALWAYS follows the chosen colour — clicking a colour
 *       that has a photo swaps the cover to it; a colour with no photo reverts to
 *       the default cover. (The "Show image" tick now only styles the small
 *       swatch, not the hero.) (2) Each swatch shows the COLOUR NAME under the
 *       circle.
 * v8.3: ONE simple rule per colour — the admin "Show image" tick.
 *   - Ticked (image colour) → the swatch shows the colour's photo AND clicking it
 *     swaps the big left cover to that photo.
 *   - Unticked (colour-only) → the swatch shows the solid colour circle, and
 *     clicking it reverts the big cover to the product's DEFAULT image (so the
 *     hero is never stuck on a previous colour). Fixes: "colour-only swatch
 *     didn't change the hero".
 *   - The colour's image link (when set) is still used for the Shopify VARIANT
 *     image (cart/checkout/email) regardless of the tick.
 * v8.2: CARD = swatches + name ONLY (per final spec).
 *   - The purchase card shows just "COLOR <name>" + the round colour swatches.
 *     The big image was removed from the card.
 *   - Picking a colour swaps the BIG LEFT cover image (hero) to that colour and
 *     selects the real Shopify variant — so the chosen colour's image + name then
 *     appear in the cart drawer, checkout, confirmation email and order pages
 *     natively (variant image must be linked via "Sync colours to Shopify").
 *   - Out-of-stock still shown on the swatch (grey + strike + "Out of stock").
 * v8.1: COLOUR CARD + ZOOM REFINEMENTS
 *   - No more hero "zoom": the old 3D auto-scale (1.25× for covers wider than
 *     0.78 ratio) blew up colour covers like the 624×786 Pastel Pink. Covers now
 *     always display at natural fit.
 *   - The purchase card shows the CHOSEN colour's large cover image + its name —
 *     no stock text in the card.
 *   - Out-of-stock is shown ONLY on the colour swatch: greyed + red diagonal
 *     strike + a small "Out of stock" caption under that colour.
 *   - Per-colour stock comes from the real Shopify variant (set per colour from
 *     the admin "Stock (this colour)" field → "Sync colours to Shopify").
 * v8.0: COLOUR-VARIANT FIXES (the three reported bugs)
 *   1. OUT-OF-STOCK PER COLOUR — each swatch now reads its real Shopify variant
 *      availability (from the printed VariantsJson: available / inventory_quantity)
 *      and an out-of-stock colour is shown greyed with a red diagonal strike +
 *      an "Out of stock" line in the card, like other shops. You can still tap it
 *      to view it; the theme keeps Add-to-Cart disabled for that colour.
 *   2. SHOWS IN THE CARD — picking a colour now updates the purchase card too:
 *      a small thumbnail of that colour, its name, and its stock — not just the
 *      big cover image. (Before, only the big hero changed.)
 *   3. RENDERS EVEN WHEN OUT OF STOCK — the swatches used to anchor to the
 *      Add-to-Cart button, but the theme prints no button when the product is
 *      out of stock, so the swatches never appeared. They now anchor to the
 *      format box / form, so colours always show.
 *   Order colour capture is unchanged: selecting a colour drives the real
 *   Shopify variant, so the colour NAME flows natively into cart/order/email.
 * v7.9: TWO COLOUR MODES, auto-detected per book:
 *   (A) VARIANT MODE — the Shopify product has real colour variants (a "Color"
 *       option with one image per colour). We let the theme's native variant
 *       engine do the work (image swap, price, add-to-cart) so the chosen
 *       colour's IMAGE + NAME appear everywhere natively: cart, order, customer
 *       email, packing slip, staff notification. We only (1) restyle the theme's
 *       swatches into clean circles using the admin `colors` hexes, and (2) keep
 *       our custom hero image in sync with the selected variant.
 *   (B) PROPERTY MODE — no Shopify variants: we render our own swatches and send
 *       the colour as a cart line-item property (properties[Color]). Name shows
 *       on the order; product-page hero swaps on tap. (v7.7/7.8 behaviour.)
 * v7.8: tapping a colour swaps the main cover (hero) image to that colour's cover.
 * v7.7: COLOR / VARIANT SELECTOR
 *   - Renders colour swatches (round colour circle OR image thumbnail) ABOVE the
 *     Format box (i.e. below the description "Read more", before the old dropdown).
 *   - Data comes from book.colors[] in the API:
 *         [{ name:"Maroon", type:"swatch", value:"#7B1E2B" },
 *          { name:"Pastel Pink", type:"image", value:"https://...jpg" }]
 *   - The chosen colour is sent to the Shopify cart as a LINE-ITEM PROPERTY
 *         <input name="properties[Color]" value="Maroon">
 *     so it shows on the Shopify order AND on admin /orders (line_items.properties).
 *   - Add-to-cart logic: nothing chosen → 1st click shows "Please select a colour"
 *     and suggests the first; 2nd click commits the first and proceeds.
 *   - No colours on a book → nothing renders, behaviour identical to v7.6 (safe).
 * v7.6: description wraps (nbsp fixed) + no invisible white text + contained.
 * Data: served by admin.goodwordindia.com/api/book/[handle] (Vercel, edge-cached)
 * Images: Hero from Shopify (auto-synced), Thumbnails from Supabase image_urls[]
 */
(function() {
'use strict';
var API_URL = 'https://admin.goodwordindia.com/api/book/';
// Label for the code shown in Details: admin picks per product whether the
// code is a real ISBN or an internal Product ID (books.code_type: 'isbn'|'id').
function codeLabel(book) {
return (book && book.code_type === 'id') ? 'Product ID' : 'ISBN';
  }
function esc(s) {
if (!s) return '';
var d = document.createElement('div');
d.textContent = s; return d.innerHTML;
  }
// Convert description HTML to clean plain text — strips tags AND decodes
// entities (&nbsp; &amp; &#39; etc.) so the preview never shows raw codes.
function htmlToText(h) {
if (!h) return '';
var d = document.createElement('div');
d.innerHTML = h;
return (d.textContent || d.innerText || '').replace(/\s+/g, ' ').trim();
  }
// Clean description HTML for safe rendering: turn non-breaking spaces into
// normal spaces (so text WRAPS instead of overflowing) and remove hardcoded
// text colors (so it uses the theme color, never invisible white-on-white).
function cleanHtml(h) {
if (!h) return '';
return h
.replace(/&nbsp;/gi, ' ')
.replace(/ /g, ' ')
.replace(/color\s*:\s*[^;"']*;?/gi, '');
  }
function fmtPrice(p) {
var n = parseFloat(p);
return isNaN(n) ? '' : 'Rs. ' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
function fmtDate(s) {
if (!s) return '';
try {
var d = new Date(s);
return ['January','February','March','April','May','June','July','August','September','October','November','December'][d.getMonth()] + ' ' + d.getFullYear();
    } catch(e) { return s; }
  }
function showPage() {
var l = document.querySelector('.gw-loader');
if (l) l.style.display = 'none';
var s = document.querySelector('.product-section');
if (s) s.style.removeProperty('display');
  }
function fetchBook(handle, cb) {
var xhr = new XMLHttpRequest();
xhr.open('GET', API_URL + encodeURIComponent(handle), true);
xhr.setRequestHeader('Accept', 'application/json');
xhr.onreadystatechange = function() {
if (xhr.readyState !== 4) return;
if (xhr.status === 200) {
try {
var b = JSON.parse(xhr.responseText);
// Sahin: title + description come from Shopify, everything else from the admin
var pd = window.theme && window.theme.productData;
if (b && pd) {
if (pd.title) b.title = pd.title;
if (pd.description) b.description_html = pd.description;
        }
cb(null, b);
      }
catch(e) { cb('parse', null); }
      } else if (xhr.status === 404) {
cb(null, null); // book not found / not active
      } else {
cb('HTTP ' + xhr.status, null);
      }
    };
xhr.send();
  }
// ── IMAGE ──
// Hero = Shopify first image (auto-synced, no manual work)
// Thumbnails = Supabase image_urls[] (you control what shows)
function renderImage(book) {
var el = document.getElementById('products-details-image');
if (!el) return;
// ── HERO: from Shopify only (first image) ──
var heroUrl = '';
var pd = window.theme && window.theme.productData;
if (pd && pd.images && pd.images.length) {
heroUrl = pd.images[0].src || pd.images[0];
    }
// Fallback to Supabase image_url if Shopify has none
if (!heroUrl && book.image_url) heroUrl = book.image_url;
if (!heroUrl) return;
// Remember the product's DEFAULT cover so colour-only swatches (no image) can
// revert the big hero back to it instead of getting stuck on a previous colour.
window.__gwDefaultHero = heroUrl.replace(/\?.*$/, '');
// ── THUMBNAILS: from Supabase image_urls[] only ──
// Filter out hero URL — prevents duplicate when same URL is saved in both Shopify + admin panel
// Same picture can arrive with different hosts/paths (Shopify theme CDN vs cdn.shopify.com/s/files), so compare by file name only
function imgKey(u) {
return String(u || '').split('?')[0].split('/').pop().toLowerCase().replace(/_\d+x\d*(?=\.)/, '');
  }
var heroBase = imgKey(heroUrl);
var thumbUrls = [];
if (book.image_urls && book.image_urls.length) {
var seenImg = {};
thumbUrls = book.image_urls.filter(function(u) {
var k = imgKey(u);
if (!k || k === heroBase || k === imgKey(book.image_url) || seenImg[k]) return false; // not the hero, not the admin cover, not a repeat
seenImg[k] = 1;
return true;
      });
    }
// imgs[0] = hero, imgs[1..] = thumbnails for strip + lightbox
var imgs = [heroUrl].concat(thumbUrls);
if (!document.getElementById('gw-css')) {
var st = document.createElement('style');
st.id = 'gw-css';
st.textContent = '@keyframes gw-spin{to{transform:rotate(360deg)}}.gw-spin-circle{width:40px;height:40px;border:4px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:gw-spin .8s linear infinite;}.tab-pane,.js-product__description{max-width:100%;overflow-wrap:break-word;word-break:break-word;} .tab-pane *,.js-product__description *{max-width:100%;} .tab-pane img{height:auto;}'
/* v8.5: kill the THEME box-shadow/border on product images so the cover +
   thumbnails are clean "just the image" like goodwordbooks (the theme adds
   box-shadow:0 3px 18px rgba(0,0,0,.2) — override it here, !important beats
   the theme stylesheet). */
+ '#gw-main-img{box-shadow:none!important;border:0!important;border-radius:0!important;background:transparent!important;}'
+ '.gw-thumb-item{box-shadow:none!important;border:0!important;border-radius:0!important;}';
document.head.appendChild(st);
    }
var current = 0;
// ── Hero ──
var heroWrap = document.createElement('div');
heroWrap.style.cssText = 'width:100%;overflow:visible;background:#fff;text-align:center;padding:5px 10px;box-sizing:border-box;';
var hero = document.createElement('img');
hero.id = 'gw-main-img';
hero.alt = book.title || '';
hero.style.cssText = 'max-width:400px;width:100%;height:auto;display:inline-block;';
hero.src = heroUrl.replace(/\?.*$/, '') + '?width=800';
heroWrap.appendChild(hero);
el.appendChild(heroWrap);
// v8.1: NO auto-zoom. The old "3D detection" scaled covers wider than 0.78
// ratio by 1.25× — which blew up colour covers like the 624×786 (0.79) Pastel
// Pink. Covers now always display at natural fit inside the column. We keep a
// reset so any earlier transform is cleared on every (re)load / colour swap.
function checkRatio() {
hero.style.transform = 'none';
heroWrap.style.paddingTop = '0';
heroWrap.style.paddingBottom = '0';
    }
if (hero.complete) checkRatio(); else hero.addEventListener('load', checkRatio);
// No thumbnails? Done.
if (thumbUrls.length === 0) return;
var THUMB = 139; // 133px thumb + 6px gap (was 86 = 80+6) — goodwordbooks size
// ── Strip wrapper ──
var stripWrap = document.createElement('div');
stripWrap.style.cssText = 'width:100%;margin-top:8px;position:relative;overflow:hidden;max-width:' + Math.min(400, Math.min(thumbUrls.length, 3) * 133 + 44) + 'px;'; // 400 = cover width (hero max-width)
// ── Track ──
var track = document.createElement('div');
track.style.cssText = 'display:flex;gap:6px;will-change:transform;';
// NO cloning — show exactly what is in Supabase, in order
// Arrows scroll left/right, clamped to real boundaries
thumbUrls.forEach(function(src, i) {
var t = document.createElement('img');
t.className = 'gw-thumb-item';
t.src = src.replace(/\?.*$/, '') + '?width=300';
t.setAttribute('data-real-idx', String(i));
t.style.cssText = 'width:133px;height:75px;object-fit:cover;cursor:pointer;flex-shrink:0;display:block;';
track.appendChild(t);
    });
stripWrap.appendChild(track);
// ── Arrows ON strip ──
var btnL = document.createElement('button');
btnL.innerHTML = '&#8249;';
btnL.style.cssText = 'position:absolute;left:0;top:0;bottom:0;z-index:4;background:none;border:none;color:#222;width:22px;font-size:20px;cursor:pointer;line-height:1;font-weight:900;';
var btnR = document.createElement('button');
btnR.innerHTML = '&#8250;';
btnR.style.cssText = 'position:absolute;right:0;top:0;bottom:0;z-index:4;background:none;border:none;color:#222;width:22px;font-size:20px;cursor:pointer;line-height:1;font-weight:900;';
stripWrap.appendChild(btnL);
stripWrap.appendChild(btnR);
el.appendChild(stripWrap);
// ── Slide logic — clamped, no looping ──
var pos = 0;
// v8.6: live scroll limit — content width minus visible width, measured at the
// moment of the interaction (offsetWidth is 0 at build time). Stops the strip
// exactly at the last thumbnail; never scrolls into blank space.
function maxPos() {
return Math.max(0, track.scrollWidth - stripWrap.clientWidth);
    }
function slideTo(newPos, animate) {
// Clamp: never before 0, never past the last visible thumbnail
newPos = Math.max(0, Math.min(newPos, maxPos()));
track.style.transition = animate ? 'transform .35s ease' : 'none';
track.style.transform = 'translateX(-' + newPos + 'px)';
pos = newPos;
    }
slideTo(0, false);
btnL.addEventListener('click', function() { slideTo(pos - THUMB, true); });
btnR.addEventListener('click', function() { slideTo(pos + THUMB, true); });
// ── Touch drag on strip ──
var tStartX = 0;
var tStartPos = 0;
var dragging = false;
stripWrap.addEventListener('touchstart', function(e) {
tStartX = e.touches[0].clientX;
tStartPos = pos;
dragging = true;
track.style.transition = 'none';
    }, { passive: true });
stripWrap.addEventListener('touchmove', function(e) {
if (!dragging) return;
var dx = tStartX - e.touches[0].clientX;
track.style.transform = 'translateX(-' + Math.max(0, Math.min(tStartPos + dx, maxPos())) + 'px)';
    }, { passive: true });
stripWrap.addEventListener('touchend', function(e) {
if (!dragging) return;
dragging = false;
var dx = tStartX - e.changedTouches[0].clientX;
var snapped = Math.round((tStartPos + dx) / THUMB) * THUMB;
slideTo(snapped, true);
    }, { passive: true });
// ── Thumb tap → lightbox (opens thumbnail images, not hero) ──
function openLightbox(idx) {
var lb = document.getElementById('gw-lightbox');
if (!lb) return;
// lightbox uses thumbUrls only
current = (idx + thumbUrls.length) % thumbUrls.length;
var lbImg = document.getElementById('gw-lb-img');
var sp = document.getElementById('gw-lb-spinner');
if (sp) sp.style.display = 'flex';
if (lbImg) {
lbImg.style.opacity = '0';
lbImg.onload = function() { lbImg.style.opacity = '1'; if (sp) sp.style.display = 'none'; };
lbImg.src = thumbUrls[current].replace(/\?.*$/, '') + '?width=1200';
      }
lb.style.display = 'flex';
    }
track.querySelectorAll('.gw-thumb-item').forEach(function(t) {
t.addEventListener('click', function() {
openLightbox(parseInt(t.getAttribute('data-real-idx')));
      });
    });
// ── Lightbox arrows + touch swipe ──
setTimeout(function() {
var lbPrev = document.getElementById('gw-lb-prev');
var lbNext = document.getElementById('gw-lb-next');
var lbImg  = document.getElementById('gw-lb-img');
var lb     = document.getElementById('gw-lightbox');
function lbGo(dir) {
current = (current + dir + thumbUrls.length) % thumbUrls.length;
var sp = document.getElementById('gw-lb-spinner');
if (sp) sp.style.display = 'flex';
if (lbImg) {
lbImg.style.opacity = '0';
lbImg.onload = function() { lbImg.style.opacity = '1'; if (sp) sp.style.display = 'none'; };
lbImg.src = thumbUrls[current].replace(/\?.*$/, '') + '?width=1200';
        }
      }
if (lbPrev) lbPrev.addEventListener('click', function(e) { e.stopPropagation(); lbGo(-1); });
if (lbNext) lbNext.addEventListener('click', function(e) { e.stopPropagation(); lbGo(1); });
var lbX = 0;
if (lb) {
lb.addEventListener('touchstart', function(e) { lbX = e.touches[0].clientX; }, { passive: true });
lb.addEventListener('touchend', function(e) {
var diff = lbX - e.changedTouches[0].clientX;
if (Math.abs(diff) > 40) lbGo(diff > 0 ? 1 : -1);
        }, { passive: true });
      }
    }, 400);
  }
// ── MIDDLE COLUMN ──
function renderMiddle(book) {
var el = document.getElementById('products-details-wrapper');
if (!el) return;
var a = book.authors || {};
el.style.marginTop = '0'; el.style.clear = 'both';
var html = '<div class="product__meta" style="text-align:left;">';
html += '<h1 class="h2 product__title" style="text-align:left;">' + esc(book.title) + '</h1>';
if (a.name) html += '<div class="product-vendor" style="text-align:left;margin:6px 0;font-size:1em;color:#1c1d1d;"><strong>By</strong> ' + esc(a.name) + '</div>';
if (book.price) {
html += '<div style="text-align:left;margin:10px 0;">';
if (book.compare_price && parseFloat(book.compare_price) > parseFloat(book.price)) {
html += '<span class="product__price on-sale" style="font-size:1.6em;">' + fmtPrice(book.price) + '</span> ';
html += '<span style="text-decoration:line-through;color:#1c1d1d;font-size:12px;font-weight:700;">' + fmtPrice(book.compare_price) + '</span>';
      } else {
html += '<span class="product__price" style="font-size:1.6em;">' + fmtPrice(book.price) + '</span>';
      }
html += '</div>';
    }
if (book.pub_date) {
html += '<p style="font-size:.88em;color:#666;margin:4px 0 12px;text-align:left;"><strong>Publication Date: </strong>' + fmtDate(book.pub_date) + '</p>';
    }
html += '</div>';
if (book.description_html) {
var plain = htmlToText(book.description_html);
if (plain.length > 300) {
html += '<div class="product__description js-product__description desktop" style="margin-top:16px;line-height:1.8;font-size:1em;text-align:left;">' +
esc(plain.substring(0, 300)) + '... ' +
'<a id="gw-readmore" style="color:#222;font-weight:700;cursor:pointer;" onmouseover="this.style.color=\'#00bcd4\'" onmouseout="this.style.color=\'#222\'">Read more</a>' +
'</div>';
      } else {
html += '<div class="product__description js-product__description desktop" style="margin-top:16px;line-height:1.8;font-size:1em;text-align:left;">' + cleanHtml(book.description_html) + '</div>';
      }
    }
el.innerHTML = html;
var btn = document.getElementById('gw-readmore');
if (btn) {
btn.addEventListener('click', function() {
var wrap = document.querySelector('.js-product-tabs-wrapper') || document.querySelector('#product-tabs-wrapper');
if (!wrap) return;
var descTab = wrap.querySelector('.tab-link');
if (descTab) descTab.click();
setTimeout(function() { wrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
var firstHdr = wrap.querySelector('.gw-hdr');
if (firstHdr && firstHdr.nextElementSibling.style.display !== 'block') firstHdr.click();
      });
    }
  }
// ── RIGHT COLUMN ──
function renderRight(book) {
if (!book.format) return;
var fd = document.querySelector('.js-formats-dropdown');
if (fd) fd.style.display = 'none';
function injectFormat() {
if (document.getElementById('gw-format-label')) return true;
var btn = document.querySelector('.btn.add-to-cart') ||
document.querySelector('[name="add"]') ||
document.querySelector('.product-form__cart-submit');
if (!btn) return false;
var wrapper = document.createElement('div');
wrapper.id = 'gw-format-label';
wrapper.style.cssText = 'margin-bottom:4px;';
var label = document.createElement('div');
label.style.cssText = 'margin-bottom:10px;display:block;text-align:left;border:1px solid #9c8b8b;background:#fff;border-radius:0;padding:5px 10px 10px;';
label.innerHTML = '<span style="font-size:.8em;color:#1c1d1d;display:block;margin-bottom:2px;">Format:</span>' +
'<span style="font-size:1em;color:#1c1d1d;display:block;">' + esc(book.format) + '</span>';
var parent = btn.parentNode;
parent.insertBefore(wrapper, btn);
wrapper.appendChild(label);
wrapper.appendChild(btn);
return true;
    }
injectFormat();
var tries = 0;
var iv = setInterval(function() {
tries++;
if (!document.getElementById('gw-format-label')) injectFormat();
if (tries >= 8) clearInterval(iv);
    }, 500);
  }
// ── COLORS / VARIANT SWATCHES ──
// book.colors = [{ name, type:'swatch'|'image', value }]
// Shown ABOVE the Format box (below description Read-more, before old dropdown).
// The chosen colour is attached to the Shopify cart as a line-item property:
//   <input name="properties[Color]" value="Maroon">  → shows on every order.
// ── VARIANT MODE HELPERS ──
// Replicates Shopify's `| handle` filter: lowercase, non-alphanumerics → "-".
function handleize(s) {
return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
// Read the product's real Shopify variants from the theme's printed JSON.
function getVariants() {
var el = document.querySelector('[id^="VariantsJson-"]');
if (el) { try { return JSON.parse(el.textContent); } catch (e) {} }
var pd = window.theme && window.theme.productData;
if (pd && pd.variants) return pd.variants;
return null;
  }
// True when the product has real colour variants (>1 variant to choose from).
function hasColorVariants() {
var v = getVariants();
return !!(v && v.length > 1);
  }
// Fire a native 'change' the theme's jQuery handlers will hear.
function fireChange(el) {
var e;
try { e = new Event('change', { bubbles: true }); }
catch (x) { e = document.createEvent('HTMLEvents'); e.initEvent('change', true, true); }
el.dispatchEvent(e);
  }
// Select a colour on the theme's NATIVE variant control (radio or dropdown) so
// the theme computes the right variant, swaps image/price, and adds it to cart.
function selectNativeVariant(colorName) {
var want = String(colorName).toLowerCase();
var ok = false;
document.querySelectorAll('.variant-wrapper input[type="radio"]').forEach(function(r) {
if (!ok && String(r.value).toLowerCase() === want) { r.checked = true; fireChange(r); ok = true; }
    });
if (ok) return true;
document.querySelectorAll('.variant-wrapper select').forEach(function(s) {
if (ok) return;
for (var i = 0; i < s.options.length; i++) {
if (String(s.options[i].value).toLowerCase() === want) { s.selectedIndex = i; fireChange(s); ok = true; break; }
      }
    });
return ok;
  }
// Find the variant object whose option value matches a colour name.
function variantByColor(variants, colorName) {
var want = String(colorName).toLowerCase();
for (var i = 0; i < variants.length; i++) {
var v = variants[i];
var vals = [v.option1, v.option2, v.option3, v.title];
for (var j = 0; j < vals.length; j++) {
if (vals[j] && String(vals[j]).toLowerCase() === want) return v;
      }
    }
return null;
  }
// Per-variant availability from the printed VariantsJson. Untracked variants
// are always available; tracked ones need inventory_quantity > 0.
function variantAvailable(v) {
if (!v) return false;
if (typeof v.available === 'boolean') return v.available;
if (!v.inventory_management) return true;
return Number(v.inventory_quantity) > 0;
  }
// Human stock label + an out-of-stock flag for one variant. The label follows
// real BUYABILITY (variantAvailable), never the raw quantity — so a colour that
// is still purchasable (e.g. "continue selling when out of stock") is NEVER
// shown as "Out of stock" while its Add-to-Cart button works. Only a genuinely
// unavailable colour shows the out-of-stock state.
function stockInfo(v) {
if (!v) return { text: '', oos: false };
if (!variantAvailable(v)) return { text: 'Out of stock', oos: true };
if (!v.inventory_management) return { text: 'In stock', oos: false };
var q = Number(v.inventory_quantity) || 0;
if (q > 0) return { text: q <= 10 ? 'In stock — only ' + q + ' left' : 'In stock', oos: false };
return { text: 'In stock', oos: false }; // available via continue-selling
  }
// VARIANT MODE picker: ONE circle row that drives the real Shopify variants.
// Hides the theme's native swatch UI (kept in DOM so selecting still works).
function renderVariantColors(book) {
if (document.getElementById('gw-color-block')) return;
var variants = getVariants();
if (!variants) return;
// Anchor: prefer the Format box, then add-to-cart, then the form card itself.
// IMPORTANT: do NOT require the add-to-cart button — when the product is out
// of stock the theme prints no button, but we must STILL show the colours.
var anchor = document.getElementById('gw-format-label')
|| document.querySelector('.btn.add-to-cart')
|| document.querySelector('[name="add"]')
|| document.querySelector('.product-form__cart-submit')
|| document.querySelector('.js-product-form__switch-format')
|| document.querySelector('.js-product-form__book')
|| document.querySelector('.product-form__inner');
if (!anchor || !anchor.parentNode) return false;
// hide the native swatch UI (visually) — it stays in the DOM and functional —
// and add the out-of-stock swatch treatment (grey + red diagonal strike).
if (!document.getElementById('gw-variant-css')) {
var st = document.createElement('style');
st.id = 'gw-variant-css';
st.textContent = '.variant-wrapper{position:absolute !important;width:1px !important;height:1px !important;overflow:hidden !important;clip:rect(0 0 0 0) !important;margin:-1px !important;padding:0 !important;border:0 !important;}'
+ '.gw-sw{position:relative;}'
+ '.gw-sw.gw-oos{filter:grayscale(1);opacity:.55;}'
+ '.gw-sw.gw-oos::after{content:"";position:absolute;inset:-1px;border-radius:50%;background:linear-gradient(to top right,transparent 44%,#c0392b 44%,#c0392b 56%,transparent 56%);}';
document.head.appendChild(st);
    }
// colours: prefer admin colours (hex/image), else derive names from variants
var colors = (book.colors && book.colors.length)
? book.colors
: variants.map(function(v) { return { name: (v.option1 || v.title), type: 'swatch', value: '' }; });
// v8.3: ONE simple rule per colour, driven by the admin "Show image" tick.
//   colorImage(c) = the colour's photo (hero, or an http(s) value). hex is NOT a photo.
//   showImage(c)  = ticked (type==='image') AND a photo exists → use the image;
//                   otherwise show the solid colour circle.
function colorImage(c) {
if (!c) return '';
if (c.hero) return c.hero;
if (c.value && /^https?:/i.test(c.value)) return c.value;
return '';
  }
function showImage(c) { return !!(c && c.type === 'image' && colorImage(c)); }
function hexOf(c) { return (c && c.value && /^#[0-9a-fA-F]{3,8}$/.test(c.value)) ? c.value : '#ddd'; }
var block = document.createElement('div');
block.id = 'gw-color-block';
block.style.cssText = 'margin:0 0 12px;text-align:left;';
var head = '<div style="margin-bottom:8px;"><span style="font-size:.75em;color:#888;text-transform:uppercase;letter-spacing:.05em;">Color</span> <span id="gw-color-name" style="font-size:1em;color:#222;font-weight:600;"></span></div>';
// Each swatch sits in a little column: the circle + (if out of stock) a small
// "Out of stock" caption right under it. Out-of-stock is shown ONLY here on the
// colour option — there is no stock text in the card.
var row = '<div id="gw-color-swatches" style="display:flex;gap:14px;flex-wrap:wrap;align-items:flex-start;">';
colors.forEach(function(c, i) {
var v = variantByColor(variants, c.name);
var oos = !variantAvailable(v);
// Swatch: photo only when "Show image" is ticked AND a photo exists; else hex.
var bg = showImage(c)
? 'background:#eee url(\'' + esc(colorImage(c)) + '\') center/cover no-repeat;'
: 'background:' + esc(hexOf(c)) + ';';
row += '<div style="display:flex;flex-direction:column;align-items:center;gap:4px;width:64px;">'
+ '<div class="gw-sw' + (oos ? ' gw-oos' : '') + '" data-i="' + i + '" role="button" tabindex="0" aria-label="' + esc(c.name) + (oos ? ' (out of stock)' : '') + '" title="' + esc(c.name) + (oos ? ' — out of stock' : '') + '" style="width:40px;height:40px;border-radius:50%;border:1px solid #ccc;cursor:pointer;box-sizing:border-box;' + bg + '"></div>'
+ '<span class="gw-sw-name" style="font-size:.66em;line-height:1.15;color:#333;text-align:center;word-break:break-word;">' + esc(c.name) + '</span>'
+ (oos ? '<span class="gw-sw-oos" style="font-size:.6em;line-height:1.1;color:#c0392b;font-weight:700;text-transform:uppercase;letter-spacing:.02em;text-align:center;">Out of stock</span>' : '')
+ '</div>';
    });
row += '</div>';
// v8.2: the card keeps ONLY the colour name + round swatches. No image block —
// the big LEFT cover is what changes when a colour is picked, and the chosen
// colour's image shows in the cart drawer (Shopify variant image) once added.
block.innerHTML = head + row;
anchor.parentNode.insertBefore(block, anchor);
function paint(i) {
block.querySelectorAll('.gw-sw').forEach(function(s, j) {
s.style.outline = (j === i) ? '2px solid #00bcd4' : 'none';
s.style.outlineOffset = '2px';
      });
    }
// Swap the big LEFT cover to reflect the chosen colour. v8.4: the hero ALWAYS
// follows the colour — if the colour has a photo (its image link, or the Shopify
// variant image), the hero shows it; a colour with no photo reverts the hero to
// the product's DEFAULT cover so it's never stuck on a previous colour. (The
// "Show image" tick only controls the small swatch look, not the hero.)
function swapHero(c, v) {
var im = document.getElementById('gw-main-img');
if (!im) return;
var url = colorImage(c) || (v && v.featured_image && v.featured_image.src) || window.__gwDefaultHero || '';
if (url) im.src = url.replace(/\?.*$/, '') + '?width=720';
    }
function choose(i) {
var c = colors[i];
var v = variantByColor(variants, c.name);
paint(i);
// drive the real Shopify variant so price / add-to-cart / order reflect the colour
selectNativeVariant(c.name);
swapHero(c, v); // image colour → its photo; colour-only → default cover
var nameEl = document.getElementById('gw-color-name'); if (nameEl) nameEl.textContent = c.name;
    }
block.querySelectorAll('.gw-sw').forEach(function(s) {
s.addEventListener('click', function() { choose(parseInt(s.getAttribute('data-i'), 10)); });
s.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(parseInt(s.getAttribute('data-i'), 10)); } });
    });
// preselect: the theme's current variant if any, else the first IN-STOCK colour.
var selEl = document.querySelector('select[name="id"]');
var startIdx = -1;
if (selEl && selEl.value) {
var cur = null;
for (var k = 0; k < variants.length; k++) if (String(variants[k].id) === String(selEl.value)) cur = variants[k];
if (cur) {
var cv = String(cur.option1 || cur.title || '').toLowerCase();
for (var z = 0; z < colors.length; z++) if (String(colors[z].name).toLowerCase() === cv) { startIdx = z; break; }
      }
    }
if (startIdx < 0) {
for (var a = 0; a < colors.length; a++) if (variantAvailable(variantByColor(variants, colors[a].name))) { startIdx = a; break; }
    }
if (startIdx < 0) startIdx = 0;
choose(startIdx);
  }
function renderColors(book) {
// VARIANT MODE: the product has real colour variants → let the theme handle
// image/cart/order natively; we just prettify swatches + sync our hero.
if (hasColorVariants()) {
try { renderVariantColors(book); } catch (e) { console.warn(e); }
return;
    }
var colors = book.colors;
if (!colors || !colors.length) return;            // no colours → safe no-op
if (document.getElementById('gw-color-block')) return; // already injected
var btn = document.querySelector('.btn.add-to-cart') ||
document.querySelector('[name="add"]') ||
document.querySelector('.product-form__cart-submit');
if (!btn) return false;
var form = btn.closest('form') || document.querySelector('.js-product-single__form');
// hidden line-item-property input — lives inside the product form
var hidden = document.getElementById('gw-color-input');
if (!hidden && form) {
hidden = document.createElement('input');
hidden.type = 'hidden';
hidden.id = 'gw-color-input';
hidden.name = 'properties[Color]';
hidden.value = '';
form.appendChild(hidden);
    }
// build the colour block
var block = document.createElement('div');
block.id = 'gw-color-block';
block.style.cssText = 'margin:0 0 12px;text-align:left;';
var head = '<div style="margin-bottom:8px;">' +
'<span style="font-size:.75em;color:#888;text-transform:uppercase;letter-spacing:.05em;">Color</span> ' +
'<span id="gw-color-name" style="font-size:1em;color:#222;font-weight:600;">Choose a color</span></div>';
var row = '<div id="gw-color-swatches" style="display:flex;gap:12px;flex-wrap:wrap;">';
colors.forEach(function(c, i) {
var isImg = c.type === 'image';
var bg = isImg
? 'background:#eee url(\'' + esc(c.value) + '\') center/cover no-repeat;'
: 'background:' + esc(c.value) + ';';
row += '<div class="gw-sw" data-i="' + i + '" role="button" tabindex="0" aria-label="' + esc(c.name) + '" title="' + esc(c.name) + '" ' +
'style="width:36px;height:36px;border-radius:50%;border:1px solid #ccc;cursor:pointer;box-sizing:border-box;' + bg + '"></div>';
    });
row += '</div>';
var hint = '<div id="gw-color-hint" style="font-size:.85em;color:#e24b4a;margin-top:6px;min-height:16px;"></div>';
block.innerHTML = head + row + hint;
// insert ABOVE the Format box (fallback: above the add-to-cart button)
var anchor = document.getElementById('gw-format-label') || btn;
anchor.parentNode.insertBefore(block, anchor);
var selected = null;
var nudged = false;
// Swap the main cover (hero) image to the selected colour's cover image.
// heroFor: explicit `hero` URL, else an image-swatch's value, else nothing.
function heroFor(c) {
return (c && c.hero) ? c.hero : ((c && c.type === 'image' && c.value) ? c.value : '');
    }
function swapHero(i) {
var url = heroFor(colors[i]);
if (!url) return;
var img = document.getElementById('gw-main-img');
if (!img) return;
img.src = url.replace(/\?.*$/, '') + '?width=720';
    }
function paint(i) {
block.querySelectorAll('.gw-sw').forEach(function(s, j) {
s.style.outline = (j === i) ? '2px solid #00bcd4' : 'none';
s.style.outlineOffset = '2px';
      });
    }
function selectColor(i) {
selected = i;
if (hidden) hidden.value = colors[i].name;
paint(i);
swapHero(i);
var nameEl = document.getElementById('gw-color-name');
if (nameEl) nameEl.textContent = colors[i].name;
var hintEl = document.getElementById('gw-color-hint');
if (hintEl) hintEl.textContent = '';
    }
block.querySelectorAll('.gw-sw').forEach(function(s) {
s.addEventListener('click', function() { selectColor(parseInt(s.getAttribute('data-i'), 10)); });
s.addEventListener('keydown', function(e) {
if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectColor(parseInt(s.getAttribute('data-i'), 10)); }
      });
    });
// Add-to-cart logic (capture phase so we run before the theme's handler):
//   colour chosen           → proceed normally
//   nothing chosen, 1st tap → block, show "Please select a color", suggest first
//   nothing chosen, 2nd tap → commit the first colour, then let the add proceed
btn.addEventListener('click', function(e) {
if (selected !== null) return; // a colour is chosen → let Shopify add it
if (!nudged) {
e.preventDefault();
e.stopImmediatePropagation();
nudged = true;
var hintEl = document.getElementById('gw-color-hint');
if (hintEl) hintEl.textContent = 'Please select a color';
paint(0); // suggest the first (highlight only, not committed yet)
var nameEl = document.getElementById('gw-color-name');
if (nameEl) nameEl.textContent = colors[0].name + ' (suggested)';
return;
      }
// 2nd tap with nothing chosen → take the first colour and proceed
selectColor(0);
// no preventDefault → form submits with properties[Color] = first colour
    }, true);
  }
// ── MOBILE DESC ──
function renderMobileDesc(book) {
var el = document.querySelector('.js-product__description.mobile');
if (!el || !book.description_html) return;
var plain = htmlToText(book.description_html);
el.innerHTML = '<p style="line-height:1.8;font-size:1em;">' + esc(plain.substring(0, 300)) +
      (plain.length > 300 ? '... <a class="gw-mob-more" style="color:#222;font-weight:700;cursor:pointer;" onmouseover="this.style.color=\'#00bcd4\'" onmouseout="this.style.color=\'#222\'">Read more</a>' : '') + '</p>';
var mBtn = el.querySelector('.gw-mob-more');
if (mBtn) {
mBtn.addEventListener('click', function() {
var wrap = document.querySelector('.js-product-tabs-wrapper') || document.querySelector('#product-tabs-wrapper');
if (!wrap) return;
var firstHdr = wrap.querySelector('.gw-hdr');
if (firstHdr && firstHdr.nextElementSibling.style.display !== 'block') firstHdr.click();
setTimeout(function() { wrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
      });
    }
  }
// ── TABS ──
function renderTabs(book) {
var wrap = document.querySelector('.js-product-tabs-wrapper') || document.querySelector('#product-tabs-wrapper');
if (!wrap) return;
var a = book.authors || {};
var hasDesc = !!book.description_html;
var hasBio  = !!(a.name);
var dHtml = '<div class="is-visible-desktop container--small"><ul class="tabs js-product-tabs" id="detailsTab">';
if (hasDesc) dHtml += '<li><a class="tab-link active" href="#gw-desc">Description</a></li>';
dHtml += '<li><a class="tab-link' + (hasDesc ? '' : ' active') + '" href="#gw-det">Details</a></li>';
if (hasBio)  dHtml += '<li><a class="tab-link" href="#gw-bio">Author Bio</a></li>';
dHtml += '</ul><div class="tab-content">';
if (hasDesc) dHtml += '<div class="tab-pane active" id="gw-desc" style="font-size:1em;line-height:1.8;">' + cleanHtml(book.description_html) + '</div>';
dHtml += '<div class="tab-pane' + (hasDesc ? '' : ' active') + '" id="gw-det">' + buildDetailsDesktop(book) + '</div>';
if (hasBio)  dHtml += '<div class="tab-pane" id="gw-bio">' + buildBio(a) + '</div>';
dHtml += '</div></div>';
var mHtml = '<div class="is-visible-mobile" style="border-bottom:1px solid #ddd;">';
if (hasDesc) mHtml += buildMobileAcc('Description', '<div style="font-size:1em;line-height:1.8;padding:12px 0;">' + cleanHtml(book.description_html) + '</div>');
mHtml += buildMobileAcc('Details', buildDetailsMobile(book));
if (hasBio)  mHtml += buildMobileAcc('Author Bio', buildBio(a));
mHtml += '</div>';
wrap.innerHTML = dHtml + mHtml;
wrap.querySelectorAll('.tab-link').forEach(function(t) {
t.addEventListener('click', function(e) {
e.preventDefault();
wrap.querySelectorAll('.tab-link').forEach(function(x) { x.classList.remove('active'); });
wrap.querySelectorAll('.tab-pane').forEach(function(x) { x.classList.remove('active'); });
t.classList.add('active');
var p = wrap.querySelector(t.getAttribute('href'));
if (p) p.classList.add('active');
      });
    });
wrap.querySelectorAll('.gw-hdr').forEach(function(h) {
h.addEventListener('click', function() {
var body = h.nextElementSibling;
var arrow = h.querySelector('.gw-arr');
// each section opens/closes on its own (like the live site); "+" becomes "−" while open
var isOpen = body && body.style.display === 'block';
if (body) body.style.display = isOpen ? 'none' : 'block';
if (arrow) arrow.classList.toggle('gw-arr--open', !isOpen);
      });
    });
  }
function buildDetailsDesktop(book) {
var rows = '';
if (book.pages)     rows += '<p style="margin:8px 0;font-size:1em;"><strong>Pages: </strong>' + esc(String(book.pages)) + '</p>';
if (book.trim_size) rows += '<p style="margin:8px 0;font-size:1em;"><strong>Trim Size: </strong>' + esc(book.trim_size) + '</p>';
if (book.isbn)      rows += '<p style="margin:8px 0;font-size:1em;"><strong>' + codeLabel(book) + ': </strong>' + esc(book.isbn) + '</p>';
if (book.language)  rows += '<p style="margin:8px 0;font-size:1em;"><strong>Language: </strong>' + esc(book.language) + '</p>';
if (!rows) return '<p style="color:#999;">No details available.</p>';
return '<div style="display:flex;align-items:flex-start;gap:20px;padding:16px 0;">' +
'<svg class="gw-info-i" width="27" height="60" viewBox="0 0 27 60" aria-hidden="true" style="flex-shrink:0"><circle cx="17.5" cy="7.5" r="7.5"/><path d="M12.5 21h13.5l-6.5 29c-.8 3.5.6 5 3.5 5H25l-1.2 4.8H11C5 59.8 2.8 56.3 4 51.2l5.3-23.6c.4-1.6-.2-2.4-1.9-2.4H4.2L5 21z"/></svg>' +
'<div style="flex:1;">' + rows + '</div></div>';
  }
function buildDetailsMobile(book) {
var h = '<ul style="list-style:none;padding:12px 0;margin:0;">';
if (book.pages)     h += '<li style="padding:6px 0;font-size:1em;"><strong>Pages: </strong>' + esc(String(book.pages)) + '</li>';
if (book.trim_size) h += '<li style="padding:6px 0;font-size:1em;"><strong>Trim Size: </strong>' + esc(book.trim_size) + '</li>';
if (book.isbn)      h += '<li style="padding:6px 0;font-size:1em;"><strong>' + codeLabel(book) + ': </strong>' + esc(book.isbn) + '</li>';
if (book.language)  h += '<li style="padding:6px 0;font-size:1em;"><strong>Language: </strong>' + esc(book.language) + '</li>';
h += '</ul>';
return h;
  }
function buildBio(a) {
var h = '<div style="display:flex;gap:16px;align-items:flex-start;flex-wrap:wrap;padding:16px 0;">';
if (a.photo_url) h += '<img src="' + esc(a.photo_url) + '" alt="" style="max-width:80px;border-radius:50%;flex-shrink:0;">';
h += '<div><p style="font-weight:600;margin:0 0 8px;">' + esc(a.name) + '</p>' +
'<p style="line-height:1.8;color:#444;margin:0;font-size:1em;">' + (a.bio || 'Author bio coming soon.') + '</p></div></div>';
return h;
  }
function buildMobileAcc(label, content) {
return '<div style="border-top:1px solid #ddd;">' +
'<div class="gw-hdr" style="display:flex;justify-content:space-between;align-items:center;padding:16px 0;cursor:pointer;user-select:none;">' +
'<span style="font-size:.85em;color:#222;letter-spacing:.18em;text-transform:uppercase;">' + label + '</span>' +
'<span class="gw-arr" style="color:#222;font-size:.85em;">▼</span>' +
'</div>' +
'<div class="gw-body" style="display:none;">' + content + '</div>' +
'</div>';
  }
// ── INIT ──
function init() {
if (!document.getElementById('gw-lightbox')) {
var lb = document.createElement('div');
lb.id = 'gw-lightbox';
lb.style.cssText = 'display:none;position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.92);align-items:center;justify-content:center;cursor:pointer;';
lb.innerHTML =
'<div id="gw-lb-spinner" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:1;pointer-events:none;"><div class="gw-spin-circle"></div></div>' +
'<button id="gw-lb-prev" style="position:absolute;left:12px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.25);border:none;color:#fff;width:52px;height:52px;border-radius:50%;font-size:36px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:2;touch-action:manipulation;">&#8249;</button>' +
'<img id="gw-lb-img" style="max-width:80vw;max-height:85vh;object-fit:contain;border-radius:8px;transition:opacity .15s;position:relative;z-index:2;" src="" alt="">' +
'<button id="gw-lb-next" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.25);border:none;color:#fff;width:52px;height:52px;border-radius:50%;font-size:36px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:2;touch-action:manipulation;">&#8250;</button>' +
'<span id="gw-lb-close" style="position:absolute;top:12px;right:16px;color:#fff;font-size:48px;line-height:1;cursor:pointer;z-index:3;">&times;</span>';
document.body.appendChild(lb);
lb.addEventListener('click', function(e) {
if (e.target === lb || e.target.id === 'gw-lb-close') lb.style.display = 'none';
      });
    }
var safe = setTimeout(showPage, 7000);
var section = document.querySelector('.product-section');
if (!section) { clearTimeout(safe); showPage(); return; }
var handle = section.getAttribute('data-product-handle');
if (!handle) { clearTimeout(safe); showPage(); return; }
fetchBook(handle, function(err, book) {
clearTimeout(safe);
if (err || !book) { console.warn('Goodword:', handle, err); showPage(); return; }
// Price always comes from Shopify (matches the cart); everything else from the admin.
var spv = window.theme && window.theme.productData && window.theme.productData.variants && window.theme.productData.variants[0];
if (spv && spv.price != null) {
book.price = spv.price / 100;
book.compare_price = spv.compare_at_price ? spv.compare_at_price / 100 : null;
}
try { renderImage(book); }      catch(e) { console.warn(e); }
try { renderMiddle(book); }     catch(e) { console.warn(e); }
try { renderMobileDesc(book); } catch(e) { console.warn(e); }
try { renderRight(book); }      catch(e) { console.warn(e); }
try { renderColors(book); }     catch(e) { console.warn(e); }
showPage();
// Tabs: render fast (150ms), then re-assert at 1200ms in case the old
// a late script may overwrite the tabs wrapper after its own failed fetch.
setTimeout(function() {
try { renderRight(book); }  catch(e) { console.warn(e); }
try { renderColors(book); } catch(e) { console.warn(e); }
try { renderTabs(book); }   catch(e) { console.warn(e); }
      }, 150);
setTimeout(function() {
try { renderColors(book); } catch(e) { console.warn(e); }
try { renderTabs(book); }   catch(e) { console.warn(e); }
      }, 1200);
    });
  }
document.readyState === 'loading'
? document.addEventListener('DOMContentLoaded', init)
: init();
})();